/**
 *  @class
 *  @function FreeShippingProgressBar
 *  Barra escalonada 2 peldanos: tier1 = $2.000 dcto, tier2 = envio gratis RM / $4.000 dcto.
 */

if (!customElements.get('free-shipping-progress-bar')) {
    let currentPercent = 0; // Store the current percentage globally
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.updateStatus();
      }

      updateStatus() {
        const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const tier1 = Math.round(parseInt(this.dataset.tier1Amount, 10) * rate);
        const tier2 = Math.round(parseInt(this.dataset.tier2Amount, 10) * rate);
        const info1 = this.querySelector('.free-shipping__info-remaining');
        const info2 = this.querySelector('.free-shipping__info-tier2');
        const info3 = this.querySelector('.free-shipping__info-eligibility');
        const currencyFormat = (window.theme && window.theme.settings.money_with_currency_format) || "${{amount}}";
        const state = cartTotal >= tier2 ? 3 : cartTotal >= tier1 ? 2 : 1;

        if (state === 1 && info1) {
          const strong = info1.querySelector('strong');
          if (strong) strong.innerHTML = formatMoney(tier1 - cartTotal, currencyFormat);
        }
        if (state === 2 && info2) {
          const strong = info2.querySelector('strong');
          if (strong) strong.innerHTML = formatMoney(tier2 - cartTotal, currencyFormat);
        }

        if (info1) info1.style.display = state === 1 ? 'block' : 'none';
        if (info2) info2.style.display = state === 2 ? 'block' : 'none';
        if (info3) info3.style.display = state === 3 ? 'block' : 'none';

        this.animateProgressBar(Math.min(cartTotal / tier2, 1));
      }

      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = currentPercent;
        const duration = 200;
        const startTime = performance.now();

        const ease = (t) => t * (2 - t);

        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);

          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${currentPercent}%`);

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            currentPercent = targetPercent;
            this.style.setProperty('--percent', `${currentPercent}%`);
          }
        };

        requestAnimationFrame(animate);
      }
    }

    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}
